// Thin wrappers around the Stripe-related Supabase Edge Functions (see
// supabase/functions/stripe-*). Mirrors the fetch style already used by
// sendPushNotification() in pushNotifications.js — plain fetch calls to
// `${SUPA_URL}/functions/v1/<name>`, authenticated with the caller's own
// Supabase session token so the function runs with that user's RLS
// permissions (except stripe-webhook, which Stripe calls directly and which
// isn't invoked from the frontend at all).
import {SUPA_URL,api} from './api';

async function callFn(token,name,body){
  try{
    const r=await fetch(`${SUPA_URL}/functions/v1/${name}`,{
      method:"POST",
      headers:{...api.h(token),"Content-Type":"application/json"},
      body:JSON.stringify(body||{}),
    });
    let json={};
    try{json=await r.json();}catch(e){}
    if(!r.ok)return{ok:false,error:json?.error||`Request failed (${r.status})`};
    return{ok:true,...json};
  }catch(e){
    console.error(`${name} failed:`,e);
    return{ok:false,error:"Couldn't reach the server. Please check your connection and try again."};
  }
}

// Starts (or resumes) a head coach's Stripe Express onboarding — returns a
// Stripe-hosted URL the browser should redirect to.
export async function startStripeOnboarding(token,orgId){
  return callFn(token,"stripe-connect-onboarding",{orgId});
}

// Pulls a fresh charges_enabled/payouts_enabled/details_submitted read from
// Stripe for a club's connected account (also refreshes it in the database).
export async function refreshStripeAccountStatus(token,orgId){
  return callFn(token,"stripe-account-status",{orgId});
}

// Creates a Stripe Checkout Session for one payment period for one player —
// returns a Checkout URL the browser should redirect to. accountRole must be
// "parent" or "player", matching who's initiating the payment.
export async function createPaymentCheckout(token,{periodId,playerId,accountRole}){
  return callFn(token,"stripe-create-checkout",{periodId,playerId,accountRole});
}

// ── pitchMGR's own subscription billing (a club paying to use the app) ──────
// Separate from everything above, which is Stripe Connect (parents paying a
// club). These mirror the same fetch/callFn pattern.

// Starts a brand-new subscription (with the trial period baked in) for a club
// that's chosen a plan but not subscribed yet — returns a Checkout URL.
export async function startBillingCheckout(token,orgId){
  return callFn(token,"stripe-billing-checkout",{orgId});
}

// Changes the tier/billing cycle/add-ons on a club's EXISTING subscription.
export async function updateBillingPlan(token,{orgId,planTier,billingCycle,parentAddon,playerAddon}){
  return callFn(token,"stripe-billing-update",{orgId,planTier,billingCycle,parentAddon,playerAddon});
}

// Cancels (or, with resume:true, un-cancels) a club's subscription at the end
// of its current period.
export async function cancelBillingSubscription(token,orgId,resume){
  return callFn(token,"stripe-billing-cancel",{orgId,resume});
}

// On-demand refresh of a club's subscription status straight from Stripe —
// used right after returning from Checkout, before the webhook necessarily lands.
export async function refreshBillingStatus(token,orgId){
  return callFn(token,"stripe-billing-status",{orgId});
}
